import { HTTP_METHODS } from "@/constants/HttpConstants";
import { IInterviewConfig } from "@/types/interviewConfig.types";
import { sendRequestToInterviewWithCredential } from "@/utils/request.utils";

// eslint-disable-next-line import/prefer-default-export
export const getInterviewConfigAPI = (interviewSlug: string) =>
  sendRequestToInterviewWithCredential<IInterviewConfig>({
    method: HTTP_METHODS.GET,
    url: `/interview/${interviewSlug}/config/`,
  });
